"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkContainsNumbersOfChildren = exports.checkContainsNumbersOfComponentChildren = exports.checkChildrenAreValid = void 0;
const react_1 = __importDefault(require("react"));
const checkChildrenAreValid = (child, supportedChildrenNames) => {
    var _a, _b;
    // This allows null children, which means in the usage there can be conditional rendering for optional children
    if (child === null) {
        return;
    }
    if (!supportedChildrenNames.includes((_a = child === null || child === void 0 ? void 0 : child.type) === null || _a === void 0 ? void 0 : _a.displayName)) {
        throw new Error(`Unexpected child: Expected to receive ${supportedChildrenNames.join(",")} but instead received ${(_b = child === null || child === void 0 ? void 0 : child.type) === null || _b === void 0 ? void 0 : _b.displayName}`);
    }
};
exports.checkChildrenAreValid = checkChildrenAreValid;
const checkContainsNumbersOfComponentChildren = ({ children, childName, minNumber, maxNumber, }) => {
    if (!(react_1.default.Children.toArray(children).filter((child) => { var _a; return ((_a = child === null || child === void 0 ? void 0 : child.type) === null || _a === void 0 ? void 0 : _a.displayName) === childName; }).length >= minNumber) ||
        !(react_1.default.Children.toArray(children).filter((child) => { var _a; return ((_a = child === null || child === void 0 ? void 0 : child.type) === null || _a === void 0 ? void 0 : _a.displayName) === childName; }).length <= maxNumber)) {
        throw new Error(`Incorrect children: Must have min ${minNumber} and max ${maxNumber} children that are a ${childName}`);
    }
};
exports.checkContainsNumbersOfComponentChildren = checkContainsNumbersOfComponentChildren;
const checkContainsNumbersOfChildren = ({ children, minNumber, maxNumber, }) => {
    if (react_1.default.Children.toArray(children).length < minNumber ||
        react_1.default.Children.toArray(children).length > maxNumber) {
        throw new Error(`Incorrect children: Can only pass between ${minNumber} and ${maxNumber} children`);
    }
};
exports.checkContainsNumbersOfChildren = checkContainsNumbersOfChildren;
//# sourceMappingURL=ActionCard.utils.js.map